module.exports = __webpack_public_path__ + "static/media/favor_green.0897fe7e.svg";